import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getfeetype, addstandardfees } from "../../store/slices/fees";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";

export default function AddFees() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        standard: "",
        session: "",
        feeCategory: "",
        totalAmount: "",
        terms: [{ term: "", amount: "" }],
    });

    const [errors, setErrors] = useState({});

    const { feestype = {} } = useSelector((state) => state.fees || []);

    const { classsectionList = [] } = useSelector((state) => state.classsection);

    useEffect(() => {
        dispatch(getfeetype())
        dispatch(fetchStandardSection())
    }, dispatch)

    console.log(feestype);
    console.log(classsectionList);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleTermChange = (index, field, value) => {
        const updatedTerms = [...formData.terms];
        updatedTerms[index][field] = value;
        setFormData({ ...formData, terms: updatedTerms });
    };

    const addTerm = () => {
        setFormData({
            ...formData,
            terms: [...formData.terms, { term: "", amount: "" }],
        });
    };

    const removeTerm = (index) => {
        const updatedTerms = formData.terms.filter((_, i) => i !== index);
        setFormData({ ...formData, terms: updatedTerms });
    };

    /* ---------- validation ---------- */
    const validate = () => {
        let newErrors = {};

        if (!formData.standard) newErrors.standard = "Please select Standard";
        if (!formData.session) newErrors.session = " Please select Session";
        if (!formData.feeCategory)
            newErrors.feeCategory = " Please select fees category ";
        if (!formData.totalAmount)
            newErrors.totalAmount = "Please enter total amount";

        formData.terms.forEach((t, index) => {
            if (!t.term)
                newErrors[`term_${index}`] = "Please enter term ";
            if (!t.amount)
                newErrors[`amount_${index}`] = "Please enter term amount";
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    /* ---------- submit ---------- */
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;

        const payload = {
            session: formData.session,
            standardId: formData.standard,
            feeDetails: [
                {
                    feeCategoryId: formData.feeCategory,
                    amount: Number(formData.totalAmount),
                    paymentBreakdown: formData.terms.map(item => ({
                        name: item.term,
                        amount: Number(item.amount)
                    }))
                }
            ],
        }
        dispatch(addstandardfees(payload))
            .unwrap()
            .then(() => {
                toast.success("Feesdetails added successfully");
                navigate(-1);
            })
            .catch((err) => {
                toast.error(err || "Failed to add Feesdetails");
            });
    };
    
    return (
        <Container>
            <div className="staff-header">
                <div className="staff-breadcrumb">
                    <Link to="/institute/home" className="crumb home">
                        Home
                    </Link>
                    <span className="crumb current">Add Fees</span>
                </div>
            </div>

            <Card className="staff-card p-4" style={{ border: "none" }}>
                <Form onSubmit={handleSubmit}>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Label>Standard</Form.Label>
                            <Form.Select
                                name="standard"
                                value={formData.standard}
                                onChange={handleChange}
                                isInvalid={!!errors.standard}
                            >
                                <option value="">Select Standard</option>
                                {classsectionList?.map((item) => (
                                    <option key={item.standardId._id} value={item.standardId._id}>
                                        {item.standardId.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {errors.standard}
                            </Form.Control.Feedback>
                        </Col>

                        <Col md={6}>
                            <Form.Label>Session</Form.Label>
                            <Form.Select
                                type="text"
                                placeholder="2025-2026"
                                name="session"
                                value={formData.session}
                                onChange={handleChange}
                                isInvalid={!!errors.session}
                            >
                                <option value="">Select session</option>
                                <option value="2025-2026">2025-2026</option>
                                <option value="2024-2025">2024-2025</option>
                                <option value="2023-2024">2023-2024</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {errors.session}
                            </Form.Control.Feedback>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Label>Fee Category</Form.Label>
                            <Form.Select
                                type="text"
                                placeholder="Tuition Fee"
                                name="feeCategory"
                                value={formData.feeCategory}
                                onChange={handleChange}
                                isInvalid={!!errors.feeCategory}
                            >
                                <option value="">Fee Category</option>
                                {feestype.map((item) => (
                                    <option key={item?._id} value={item?._id}>
                                        {item?.name}
                                    </option>
                                ))}


                            </Form.Select>

                            <Form.Control.Feedback type="invalid">
                                {errors.feeCategory}
                            </Form.Control.Feedback>
                        </Col>

                        <Col md={6}>
                            <Form.Label>Total Amount</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="50000"
                                name="totalAmount"
                                value={formData.totalAmount}
                                onChange={handleChange}
                                isInvalid={!!errors.totalAmount}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.totalAmount}
                            </Form.Control.Feedback>
                        </Col>
                    </Row>


                    <h6 className="mb-2">Term Breakdown</h6>

                    {formData.terms.map((t, index) => (
                        <Row key={index} className="align-items-center mb-2">
                            <Col md={5}>
                                <Form.Control
                                    placeholder="Term name (e.g. Term-1)"
                                    value={t.term}
                                    onChange={(e) =>
                                        handleTermChange(index, "term", e.target.value)
                                    }
                                    isInvalid={!!errors[`term_${index}`]}
                                />
                            </Col>

                            <Col md={5}>
                                <Form.Control
                                    type="text"
                                    placeholder="Amount"
                                    value={t.amount}
                                    onChange={(e) =>
                                        handleTermChange(index, "amount", e.target.value)
                                    }
                                    isInvalid={!!errors[`amount_${index}`]}
                                />
                            </Col>

                            <Col md={2} className="d-flex gap-2">
                                <Button
                                    variant="outline-primary"
                                    onClick={addTerm}
                                    type="button"
                                >
                                    <FiPlus />
                                </Button>

                                {formData.terms.length > 1 && (
                                    <Button
                                        variant="outline-danger"
                                        onClick={() => removeTerm(index)}
                                        type="button"
                                    >
                                        <FiTrash2 />
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    ))}
                    <div className="form-actions">
                        <button
                            type="button"
                            className="btn-cancel"
                            onClick={() => navigate(-1)}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="btn-submit">
                            Submit
                        </button>
                    </div>
                </Form>
            </Card>
        </Container>
    );
}
